import { assignInlineVars } from '@vanilla-extract/dynamic';
import React, { ReactNode } from 'react';

import {
	barClass,
	barColor,
	barContainerClass,
	barRate,
	containerClass,
	graphContainerClass,
	legendClass,
	legendColorClass,
	legendContainerClass,
	legendSubTextClass,
	legendTextClass,
	legendTextContainerClass,
} from './style.css';
import ColoredChartText from '../colored-chart-text/ColoredChartText';

export interface RatioSingleBarChartItem {
	label?: string;
	color?: string;
	value?: string;
	subValue?: string;
	valuePercentage?: number;
}

export interface RatioSingleBarChartProps {
	desc?: ReactNode;
	subDesc?: string;

	items?: RatioSingleBarChartItem[];
	isLegend?: boolean;
	align?: 'vertical' | 'horizontal';

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const RatioSingleBarChart = ({
	desc,
	subDesc,
	isLegend,
	align = 'vertical',
	isLoading,
	isError,
	lackOfPermission,
	...props
}: RatioSingleBarChartProps) => {
	const items = props.items
		? isLoading || isError
			? []
			: lackOfPermission
			? props.items.map((item) => ({ ...item, value: '00%', valuePercentage: 50 }))
			: props.items
		: [];

	const status = { isLoading, isError, lackOfPermission };

	return (
		<div className={containerClass({ align })}>
			<ColoredChartText
				subText={subDesc}
				isLoading={isLoading}
				isError={isError}
				lackOfPermission={lackOfPermission}
			>
				{desc}
			</ColoredChartText>

			<div className={graphContainerClass}>
				<div className={barContainerClass}>
					{items.map((item, idx) => (
						<div
							key={idx}
							className={barClass}
							style={assignInlineVars({
								[barRate]: `${item.valuePercentage ?? 0}%`,
								[barColor]: item.color,
							})}
						/>
					))}
				</div>

				{isLegend && (
					<div className={legendContainerClass}>
						{items.map((item, idx) => (
							<div key={idx} className={legendTextContainerClass}>
								<div className={legendClass}>
									<div
										className={legendColorClass}
										style={assignInlineVars({ [barColor]: item.color })}
									/>
									<p className={legendTextClass}>{`${item.label}: ${item.value}`}</p>
								</div>
								{item.subValue && <p className={legendSubTextClass}>{item.subValue}</p>}
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default RatioSingleBarChart;
